import 'isomorphic-fetch';
import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { setContext } from 'apollo-link-context';

const getClient = (auth) => {
  const httpLink = createHttpLink({ uri: process.env.GRAPHQL_ENDPOINT });

  const authMiddleware = setContext(operation =>
    auth.getIdToken().then(token => ({
      headers: {
        authorization: token,
      },
    })),
  );

  const httpLinkWithAuthToken = authMiddleware.concat(httpLink);
  return new ApolloClient({
    link: httpLinkWithAuthToken,
    cache: new InMemoryCache(),
  });
};

export default getClient;



// WEBPACK FOOTER //
// ./src/app/clients/apollo-client.js